import { version } from "../package.json";

export const Version = version;

/** 插件 ID */
export const PluginId = "video.js";
